import { render } from "./OrderTask.vue?vue&type=template&id=01c15771&scoped=true&ts=true"
import script from "./OrderTask.vue?vue&type=script&lang=ts"
export * from "./OrderTask.vue?vue&type=script&lang=ts"

import "./OrderTask.vue?vue&type=style&index=0&id=01c15771&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c15771"]])

export default __exports__